<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('my.order_history')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
      <van-pull-refresh :pulling-text="$t('loading.refresh')" :loading-text="$t('loading.loading')"  :loosing-text="$t('loading.loss')" :success-text="$t('loading.success')" v-model="isLoading" @refresh="onRefresh">
        <div class="debug-info" style="color: #f3c7a2; text-align: center; padding: 10px; font-size: 14px;">
          {{ $t('game_record.debug_info', { count: list.length, total: totalPages }) }}
        </div>
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <template v-else>
          <div class="item_list" v-for="(order, key) in list" :key="key">
          <!-- 订单头部信息 -->
          <div class="order-header">
            <div class="order-id">
              <span class="label">{{ $t('game_record.order_number') }}</span>
              <span class="value">{{ order.id }}</span>
            </div>
                         <div class="order-status">
               <span v-if="order.status === 1" class="status-success">{{ $t('game_record.status_completed') }}</span>
               <span v-else-if="order.status === 2" class="status-pending">{{ $t('game_record.status_processing') }}</span>
               <span v-else>
                 <button 
                   class="complete-order-btn-inline" 
                   @click="completeOrder(order)"
                   :disabled="order.completing"
                 >
                   <span v-if="order.completing" class="loading-spinner"></span>
                   <span v-if="order.completing">{{ $t('game_record.processing') }}</span>
                   <span v-else>{{ $t('game_record.complete_order') }}</span>
                 </button>
               </span>
             </div>
          </div>


          <!-- 金额信息 -->
          <div class="amount-info">
            <div class="amount-row">
              <span class="label">{{ $t('game_record.order_amount') }}</span>
              <span class="value">${{ order.total_amount }}</span>
            </div>
            <div class="amount-row">
              <span class="label">{{ $t('game_record.commission') }}</span>
              <span class="value commission">${{ order.commission }}</span>
            </div>

          </div>

                     <!-- 时间信息 -->
           <div class="time-info">
             <div class="time-row">
               <span class="label">{{ $t('game_record.create_time') }}</span>
               <span class="value">{{ formatTime(order.create_time) }}</span>
             </div>
           </div>
           
           
        </div>
        </template>
      </van-pull-refresh>

      <!-- 分页 -->
      <div class="pagination" v-if="totalPages > 1 || list.length > limit">
        <van-button 
          :disabled="currentPage === 1" 
          @click="changePage(currentPage - 1)"
          class="page-btn"
        >
          {{ $t('game_record.previous_page') }}
        </van-button>
        <span class="page-info">{{ $t('game_record.page_info', { current: currentPage, total: totalPages }) }}</span>
        <van-button 
          :disabled="currentPage === totalPages" 
          @click="changePage(currentPage + 1)"
          class="page-btn"
        >
          {{ $t('game_record.next_page') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {http} from '@/http/index'

export default {
  data() {
    return {
      isLoading: false,
      list: [],
      currentPage: 1,
      totalPages: 1,
      limit: 10
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    
    onRefresh() {
      this.getOrderHistory();
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },

    // 获取订单历史
    async getOrderHistory() {
      try {
        const result = await http({
          method: 'get',
          url: 'getOrderHistory',
          data: {
            page: this.currentPage,
            limit: this.limit
          }
        });
        
        if (result && result.code === 200) {
          // 数据在 data2 字段中
          console.log('获取订单历史成功:', result);
          
          // 检查 data2 字段
          if (result.data2 && result.data2.data) {
            this.list = result.data2.data || [];
            this.totalPages = result.data2.total_pages || 1;
            console.log('从 data2 获取订单列表:', this.list);
            console.log('从 data2 获取总页数:', this.totalPages);
          } else if (result.data && Array.isArray(result.data)) {
            // 备用：检查 data 字段
            this.list = result.data || [];
            this.totalPages = result.total_pages || 1;
            console.log('从 data 获取订单列表:', this.list);
            console.log('从 data 获取总页数:', this.totalPages);
          } else {
            console.error('未找到订单数据');
            this.list = [];
            this.totalPages = 1;
          }
        } else {
          console.error('获取订单历史失败:', result.msg);
          this.$toast(result.msg || this.$t('game_record.get_order_history_failed'));
        }
      } catch (error) {
        console.error('获取订单历史出错:', error);
        this.$toast(this.$t('game_record.get_order_history_failed_retry'));
      }
    },

    // 切换页面
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getOrderHistory();
      }
    },

         // 格式化时间
     formatTime(timeStr) {
       if (!timeStr) return this.$t('game_record.unknown');
       // 如果已经是格式化的时间字符串，直接返回
       if (typeof timeStr === 'string' && timeStr.includes('-')) {
         return timeStr;
       }
       // 如果是时间戳，转换为日期
       if (typeof timeStr === 'number') {
         const date = new Date(timeStr * 1000);
         const year = date.getFullYear();
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const day = String(date.getDate()).padStart(2, '0');
         const hours = String(date.getHours()).padStart(2, '0');
         const minutes = String(date.getMinutes()).padStart(2, '0');
         const seconds = String(date.getSeconds()).padStart(2, '0');
         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
       }
       return timeStr;
     },
     
     // 完成订单（付款）
     async completeOrder(order) {
       // 设置加载状态
       this.$set(order, 'completing', true);
       
       try {
         const result = await http({
           method: 'post',
           url: 'placeOrder',
           data: {
             member_id: 1,
             order_id: order.id,
             quantity: order.quantity || 1
           }
         });
         
         if (result && result.code === 200) {
           this.$toast(this.$t('game_record.order_complete_success'));
           // 刷新订单列表
           this.getOrderHistory();
         } else {
           this.$toast(this.$t('game_record.order_complete_failed') + (result.msg || this.$t('game_record.unknown')));
         }
       } catch (error) {
         console.error('完成订单出错:', error);
         this.$toast(this.$t('game_record.order_complete_failed_retry'));
       } finally {
         // 清除加载状态
         this.$set(order, 'completing', false);
       }
     }
  },
  
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    } else {
      this.getOrderHistory();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 20px;
  margin: 20px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 15px;
  color: #f3c7a2;
  border: 1px solid #766350;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

// 订单头部
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #766350;
}

.order-id .label {
  font-size: 28px;
  color: #9b9b9b;
}

.order-id .value {
  font-size: 28px;
  font-weight: 700;
  color: #f3c7a2;
}

.order-status .status-success {
  color: #07c160;
  font-weight: 700;
  font-size: 26px;
}

.order-status .status-pending {
  color: #ff9500;
  font-weight: 700;
  font-size: 26px;
}

.order-status .status-cancelled {
  color: #ff3b30;
  font-weight: 700;
  font-size: 26px;
}

// 商品信息
.goods-info {
  margin-bottom: 20px;
}

.goods-name {
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
  margin-bottom: 10px;
  line-height: 1.4;
}

.goods-details {
  display: flex;
  gap: 20px;
}

.goods-details span {
  font-size: 26px;
  color: #9b9b9b;
}

.goods-details .card-id {
  color: #ff9500;
  font-weight: 600;
}

// 金额信息
.amount-info {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(118, 99, 80, 0.1);
  border-radius: 10px;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.amount-row:last-child {
  margin-bottom: 0;
}

.amount-row .label {
  font-size: 26px;
  color: #9b9b9b;
}

.amount-row .value {
  font-size: 28px;
  font-weight: 700;
  color: #f3c7a2;
}

.amount-row .commission {
  color: #07c160;
}

// 时间信息
.time-info {
  padding-top: 15px;
  border-top: 1px solid #766350;
}

.time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.time-row:last-child {
  margin-bottom: 0;
}

.time-row .label {
  font-size: 24px;
  color: #9b9b9b;
}

.time-row .value {
  font-size: 24px;
  color: #f3c7a2;
}

// 内联完成订单按钮
.complete-order-btn-inline {
  background: linear-gradient(120deg, #07c160, #059669);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.complete-order-btn-inline:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

// 加载动画
.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.complete-order-btn-inline:hover {
  background: linear-gradient(120deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.3);
}

.complete-order-btn-inline:active {
  transform: translateY(0);
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 30px 0;
  padding: 20px;
}

.page-btn {
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  color: #f3c7a2;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 26px;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 28px;
  color: #f3c7a2;
  font-weight: 700;
}

// 移动端适配
@media (max-width: 768px) {
  .item_list {
    padding: 15px;
    margin: 15px 5px;
  }
  
  .goods-name {
    font-size: 28px;
  }
  
  .order-id .value,
  .order-id .label {
    font-size: 24px;
  }
  
  .amount-row .value,
  .amount-row .label {
    font-size: 24px;
  }
  
  .time-row .value,
  .time-row .label {
    font-size: 22px;
  }
}
</style>
